module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_9006.721a6fb5.png";